module.exports = __webpack_public_path__ + "img/icon3.0cfce293.svg";